/* FTF : logo 3D qui tourne (page d'attente). Three.js est hébergé dans le thème, aucun appel à un site tiers.
   Usage : <div data-logo3d data-three="…three.module.min.js" data-svgloader="…SVGLoader.js" data-svg="…ftf-logo-3d.svg"> */
const el = document.querySelector('[data-logo3d]');
if (el) {
  const { three, svgloader, svg, size, speed } = el.dataset;
  (async () => {
    const THREE = await import(three);
    const { SVGLoader } = await import(svgloader);
    const svgText = await (await fetch(svg)).text();
    const renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true });
    renderer.setPixelRatio(Math.min(2, window.devicePixelRatio || 1));
    renderer.outputColorSpace = THREE.SRGBColorSpace;
    renderer.domElement.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;opacity:0;transition:opacity .8s steps(4)';
    el.appendChild(renderer.domElement);
    const scene = new THREE.Scene();
    const camera = new THREE.PerspectiveCamera(35, 1, 0.1, 100);
    const shapes = [];
    new SVGLoader().parse(svgText).paths.forEach((p) => shapes.push(...SVGLoader.createShapes(p)));
    const geo = new THREE.ExtrudeGeometry(shapes, { depth: 34, bevelEnabled: true, bevelThickness: 3, bevelSize: 1.6, bevelSegments: 2, curveSegments: 6 });
    geo.center();
    const mesh = new THREE.Mesh(geo, [
      new THREE.MeshStandardMaterial({ color: 0xf2f2f2, roughness: 0.5, metalness: 0.15 }),
      new THREE.MeshStandardMaterial({ color: 0x8a8a8a, roughness: 0.7, metalness: 0.1 }),
    ]);
    const s = 3.2 / 349;
    mesh.scale.set(s, -s, s);
    const pivot = new THREE.Group(); pivot.add(mesh); scene.add(pivot);
    scene.add(new THREE.AmbientLight(0xffffff, 0.35));
    const key = new THREE.DirectionalLight(0xffffff, 2.4); key.position.set(4, 5, 7); scene.add(key);
    const rim = new THREE.DirectionalLight(0xffffff, 1.6); rim.position.set(-6, 1, -5); scene.add(rim);
    const red = new THREE.PointLight(0xff2a1a, 6, 9); red.position.set(-2.5, -2, 2.5); scene.add(red);
    const T = Math.tan(THREE.MathUtils.degToRad(17.5));
    const frac = Number(size) || 0.42;
    const resize = () => {
      const w = el.clientWidth, h = el.clientHeight; if (!w || !h) return;
      renderer.setSize(w, h, false); camera.aspect = w / h; camera.updateProjectionMatrix();
      camera.position.set(0, 0, Math.max(3.2 / (2 * T * frac), 3.1 / (2 * T * camera.aspect * Math.min(0.72, frac * 1.6))));
    };
    resize(); addEventListener('resize', resize);
    const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
    let last = performance.now(), a = 0;
    const loop = (now) => {
      requestAnimationFrame(loop);
      const dt = Math.min(0.05, (now - last) / 1000); last = now;
      a += dt * (Number(speed) || 0.9) * (reduce ? 0.3 : 1);
      pivot.rotation.y = a;
      pivot.position.y = reduce ? 0 : Math.sin(now / 1400) * 0.05;
      renderer.render(scene, camera);
    };
    requestAnimationFrame(loop);
    requestAnimationFrame(() => {
      renderer.domElement.style.opacity = 1;
      const flat = document.querySelector('[data-logo-flat]'); if (flat) flat.style.opacity = 0;
    });
  })().catch(() => { /* pas de WebGL : le logo plat reste affiché */ });
}
